import { getAppState } from "../appState";
import { adminUserId } from "../consts";
import { sleepAsync } from "../functions";
import { indexedDBStorage } from "./indexedDBStorage";

function getSFetchStorageKey(url: string) {
    return "sFetchJson_" + url;
}

export async function sFetchJson<T>(
    url: string,
    callbackUsingNewestData?: (fetchedData: T) => void
): Promise<T> {
    const storageKey = getSFetchStorageKey(url);
    const storageData = await indexedDBStorage.getItemAsync(storageKey);

    if (storageData) {
        sleepAsync(100).then(async () => {
            const data = await fetchAndStoreData<T>(url, storageKey);
            if (callbackUsingNewestData) {
                callbackUsingNewestData(data);
            }
        });
        return JSON.parse(storageData);
    }

    return fetchAndStoreData<T>(url, storageKey);
}

// エラー処理を含んだ、ストレージ保存専用の非同期関数を定義
const saveDataToStorage = async (storageKey: string, data: any) => {
    try {
        await sleepAsync(1);
        await indexedDBStorage.setItemAsync(storageKey, JSON.stringify(data));
    } catch (error) {
        if (getAppState().user?.userId == adminUserId) {
            alert(
                `Failed to save data to IndexedDB for key: ${storageKey}. Error: ${error?.toString()}`
            );
        }
    }
};

const fetchAndStoreData = async <T>(
    url: string,
    storageKey: string
): Promise<T> => {
    const result = await fetch(url);
    const data = await result.json();

    // await せずに呼び出すことで、ストレージへの保存を待たずに data を返す
    void saveDataToStorage(storageKey, data);

    return data;
};
